import ReactECharts, { EChartsOption } from 'echarts-for-react'
import { RefObject, useEffect, useRef, useState } from 'react'

interface EChartsLayoutProps {
  echartsOptions: EChartsOption
  height: string
}

export const EChartsLayout = ({ echartsOptions, height }: EChartsLayoutProps) => {
  const ref: RefObject<HTMLDivElement> = useRef(null)
  const [width, setWidth] = useState<number>(0)

  useEffect(() => {
    if (ref && ref.current) {
      setWidth(ref.current.clientWidth as number)
    }
  })

  return (
    <div className="w-full" ref={ref}>
      <ReactECharts
        option={echartsOptions}
        style={{
          height: height,
          width: width,
        }}
      />
    </div>
  )
}
